import { useState } from "react";
import { motion } from "framer-motion";
import { GALLERY } from "@/lib/config";
import { ArrowRight, Sparkles } from "lucide-react";

const Card = ({ item, i }) => {
  const [showAfter, setShowAfter] = useState(true);
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: i * 0.1 }}
      className="rounded-3xl bg-white border border-slate-200 shadow-sm overflow-hidden"
      data-testid={`gallery-item-${i}`}
    >
      <div className="grid grid-cols-2">
        <div className="relative">
          <img src={item.before} alt={`${item.title} before cleaning`} className="h-72 w-full object-cover object-center" />
          <span className="absolute top-3 left-3 rounded-full bg-slate-900/80 px-3 py-1 text-xs font-bold text-white">BEFORE</span>
        </div>
        <div className="relative border-l-4 border-white">
          <img src={item.after} alt={`${item.title} after cleaning`} className="h-72 w-full object-cover object-center" />
          <span className="absolute top-3 right-3 rounded-full bg-boco-green px-3 py-1 text-xs font-bold text-boco-navy">AFTER</span>
          <div className="absolute left-0 top-1/2 -translate-x-1/2 -translate-y-1/2 flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-md ring-1 ring-slate-200">
            <ArrowRight className="h-4 w-4 text-boco-navy" />
          </div>
        </div>
      </div>
      <div className="flex items-center gap-2 px-5 py-4">
        <Sparkles className="h-4 w-4 text-boco-green" />
        <span className="font-display font-bold text-boco-navy">{item.title}</span>
      </div>
    </motion.div>
  );
};

export const Gallery = () => (
  <section id="gallery" className="mx-auto max-w-7xl px-5 sm:px-8 py-20">
    <div className="text-center">
      <div className="text-xs font-bold tracking-[0.2em] text-boco-green">SEE THE DIFFERENCE</div>
      <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-black text-boco-navy tracking-tight">
        Real Before &amp; After Results
      </h2>
      <p className="mt-3 text-slate-600 max-w-2xl mx-auto">
        We remove dirt, grime, bacteria and odors — leaving your cans fresh, clean and sanitized inside and out.
      </p>
    </div>
    <div className="mt-12 grid gap-6 md:grid-cols-2">
      {GALLERY.map((item, i) => (<Card key={item.title} item={item} i={i} />))}
    </div>
  </section>
);
